import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({
  ChildComponent,
  isPrivateRoute = true,
  allowedRoles = [], // optional for future RBAC
  ...props
}) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const userRole = useSelector((state) => state.auth.user?.role); // optional for RBAC

  if (isPrivateRoute && !isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!isPrivateRoute && isAuthenticated) {
    return <Navigate to="/" />;
  }

  // Optional: role-based access control (extend later)
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  return <ChildComponent {...props} />;
};

export default ProtectedRoute;
